import React, { useEffect, useState } from "react";
import { useMutation, useQuery } from "react-query";
import {
    _api_get_justificatifs,
    _api_get_list_reasons,
    _api_post_step_document_and_details,
} from "../api";
import { useForm } from "react-hook-form";
import { func_format_data_list_reason, onSubmit } from "../utils/func.reasons";
import { ROUTES } from "../../../constants/routes";
import { useNavigate } from "react-router-dom";
import { useSetStep, useStepNumber } from "../stores/useStepNumber";
import { useUserOffboarding } from "./useUserOffboarding";

const useLogicJustification = () => {
    // * CONSTANTS
    const QUERY_KEY = "JUSTIFICATIF";

    // * STATES
    // * STATES
    // * STATES
    const navigate = useNavigate();
    const [filesAcceptedBack, setFilesAcceptedBack] = useState([]); // tous les fichiers validés par le backend - upload document

    // * HOOKS
    // * HOOKS
    // * HOOKS
    useSetStep(2);
    const { user_offboarding } = useUserOffboarding();

    // * FORMS
    // * FORMS
    // * FORMS
    const methods = useForm({
        defaultValues: {
            reason: null,
        },
    });

    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // * QUERIES & MUTATIONS
    // get information justification
    const { data, isLoading, isFetching } = useQuery(
        [QUERY_KEY],
        () => {
            return _api_get_justificatifs({ id_user: user_offboarding.id });
        },
        {
            refetchOnWindowFocus: false,
            onSuccess: (data) => {
                if (data.reason.value !== 0) {
                    // mettre une valeur par défaut
                    methods.setValue("reason", {
                        id: data.reason.value,
                        key: data.reason.value,
                        name: data.reason.value_str,
                    });
                }
                // documents aussi
                setFilesAcceptedBack(
                    data.documents.map((document) => ({
                        ...document,
                        name: document.name,
                        size: document.filesize,
                        original_filename: document.name,
                        is_default: true,
                    }))
                );
                return;
            },
        }
    );
    // get list of type de motifs
    const { data: list_reasons, isLoading: is_loading_list_reason } = useQuery(
        [QUERY_KEY + "::list_reasons"],
        () => {
            return _api_get_list_reasons();
        },
        {
            enabled: data !== null && data !== undefined,
            onSuccess: (response) => {
                // pas de reason, il faut prendre la première de la liste.
                // if (data.reason.value === 0) {
                //     methods.setValue("reason", {
                //         id: response.at(0).id,
                //         key: response.at(0).id,
                //         name: response.at(0).name,
                //     });
                // }

                return;
            },
        }
    );
    // POST step justificatifs
    const { isLoading: is_loading_mutate, mutate } = useMutation(
        (data) => {
            return _api_post_step_document_and_details(data);
        },
        {
            onSuccess: (data) => {
                if (data?.success) {
                    return navigate(
                        `${ROUTES.offboarding.prepare_offboarding}/leave_balances${location.search}`
                    );
                }
                return alert(data?.message);
            },
        }
    );

    return {
        query: {
            data,
            isLoading,
            isFetching,
        },
        query_list_reasons: {
            data: list_reasons,
            isLoading: is_loading_list_reason,
            formated_data: func_format_data_list_reason(list_reasons),
        },
        form: {
            ...methods,
            onSubmit: (data, files) => {
                onSubmit(data, files, mutate, user_offboarding.id);
            },
        },
        mutation: {
            isLoading: is_loading_mutate,
            mutate_step_documents: mutate,
        },
        dropzone: {
            files: filesAcceptedBack,
            setFiles: setFilesAcceptedBack,
        },
        navigation: {
            buttonBackStep: (e) => {
                e.preventDefault();
                return navigate(
                    `${ROUTES.offboarding.prepare_offboarding}/departure${location.search}`
                );
            },
        },
    };
};

export default useLogicJustification;
